import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import FabricationServices from './components/FabricationServices';
import Contact from './components/Contact';
import MapSection from './components/MapSection';
import Footer from './components/Footer';

function App() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
      
      // Show back to top button after scrolling 300px
      setShowBackToTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };



  return (
    <div className="App">
      {/* Scroll Progress Bar */}
      <div 
        className="scroll-progress" 
        style={{ width: `${scrollProgress}%` }}
      ></div>
      
      <Navbar />
      <Hero />
      <About />
      <Services />
      <FabricationServices />
      <Contact />
      <MapSection />
      <Footer />

      {/* Floating Action Buttons */}
      <div className="floating-actions">
        <button 
          className={`back-to-top ${showBackToTop ? 'visible' : ''}`}
          onClick={scrollToTop}
          title="Back to Top"
        >
          <img src="/icons/up-arrow.svg" alt="Up Arrow" className="floating-icon" />
        </button>
        
        <a 
          href="https://wa.me/971565689492?text=Hi! I'm interested in getting a quote for powder coating services."
          target="_blank"
          rel="noopener noreferrer"
          className="floating-contact"
          title="Get Quote"
        >
          <img src="/icons/whatsapp.svg" alt="WhatsApp" className="floating-icon" />
          <span>Get Quote</span>
        </a>
      </div>

      {/* Loading Screen */}
      <div className="loading-screen">
        <div className="loading-content">
          <div className="loading-logo">
            <img
              src="/loader-logo.svg"
              alt="Glitter Logo"
              className="loading-logo-image"
            />
          </div>
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    </div>
  );
}

export default App; 